import styled from '@emotion/styled';
import { colors } from 'theme/colors';
import { Box, Theme } from '@mui/material';
import { Chips } from 'components/atoms/Chips';

export const StyledSidebarWrapper = styled(Box)`
  ${({ theme }) => `
    ${(theme as Theme).breakpoints.up('xs')} {
        max-width: 100%;
        z-index: 1111;
      };
    ${(theme as Theme).breakpoints.up('sm')} {
      max-width: 350px;
      };
    ${(theme as Theme).breakpoints.up('md')} {
      max-width: 450px;
      };
      `};
  height: calc(100vh - 252px);
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1001;
  background: ${colors.white};
  border-left: 1px solid ${colors.gray300};
  padding: 20px;
  overflow-x: hidden;
  width: 370px;
`;

export const StyledCloseIcon = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-width: 32px;
  border-radius: 4px;
  cursor: pointer;
`;

export const StyledChips = styled(Chips)`
  font-weight: bold;
  cursor: pointer;
`;

export const StyledItem = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 68;
  gap: 16px;
  padding: 16px;
  border-radius: 4px;
  background: ${colors.primary15};
  border: 1px solid ${colors.primary25};
  cursor: pointer;
  &:hover {
    background:  ${colors.primary25};
  }
  &:active {
    background:  ${colors.white};
    border: 1px solid:  ${colors.primary900};
  }
`;
